import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { AdminStationsEditPage } from './edit/AdminStationsEditPage';

export function AdminStationsEditPageWrapper() {
  return (
    <StationPageWrapper>
      <AdminStationsEditPage />
    </StationPageWrapper>
  );
}
